import api from '@/api';
import { proxy } from 'valtio';

class Core {
    dataByWells = {};
    groupsByWells = {};

    async fetchData(wellId) {
        try {
            const data = await api.carottage.fetchCore({ wellIds: [wellId] });
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    setData(wellId, data, groups) {
        this.dataByWells[wellId] = data;
        this.groupsByWells[wellId] = groups;
    }

    async getData(wellId) {
        let data = null;
        if (wellId in this.dataByWells && wellId in this.groupsByWells) {
            return;
        } else {
            data = await this.fetchData(wellId);
            this.setData(wellId, data?.coreDataByWell?.[wellId] ?? {}, data?.coreGroups);
        }
        return data;
    }
}

export const core = proxy(new Core());
